import * as types from './types';

export const loaderOn = () => ({
    type: types.SHOW_LOADER,
});

export const loaderOff = () => ({
    type: types.HIDE_LOADER,
});
